import { useQuery } from "@tanstack/react-query";
import { fetchCompanyMatch } from "../services/companiesServices";

export const useCompanyDetails = (clientId) => {
  const {
    data: companyDetails,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["fetchCompanyMatch", clientId],
    queryFn: () => fetchCompanyMatch(clientId),
    enabled: !!clientId, // Only fetch if clientId exists
  });

  const companyName = isLoading
    ? "Loading Company..."
    : isError || !companyDetails
    ? "Unknown Company"
    : companyDetails.companyName;

  return { companyDetails, companyName, isLoading, isError };
};
